import { Department } from "./Department";

export type ScheduleDay = {
  Date: string;
  Slots: Array<Slot>;
  Department: Department;
  VisitTypes: [{}];
};

export type Slot = {
  Time: string;
  DisplayTime: string;
  ArrivalTime: string;
};
